import { Component, OnInit } from '@angular/core';
import { ApiService } from 'src/app/Services/api.service';
declare const animateValue: any;
declare const Swal;

import { Router } from '@angular/router';
import { CommonServices } from 'src/app/Services/common.service';
import { StorageService } from 'src/app/Services/storage.service';
import { SweetAlert } from 'src/app/Services/sweetalet.service';
import { Observable } from 'rxjs';
import { debounceTime, distinctUntilChanged } from 'rxjs/operators';
import { LoaderService } from 'src/app/Services/loader.service';
import { ExcelExportService } from 'src/app/Services/excel.service';
import { resolve } from 'dns';
import { FieldMapPipe } from 'src/app/pipe/fieldMap.pipe';
import { config } from 'process';

@Component({
  selector: 'app-manage-route',
  templateUrl: './manageRoute.component.html',
  styleUrls: ['./manageRoute.component.css']
})
export class ManageRouteComponent implements OnInit {

  public routeData: any = [];
  public vehicleData: any = {};
  public userData: any;
  public noDataFoundEnable: boolean = false;
  public searchShow: boolean = false;
  public isShowSearchAnother:boolean = false;
  public emptySrch:boolean = false;
  public tableShow: boolean = false;
  public filterTable: boolean = true;
  public  activePanel: string = 'Analyze';//'PickupPoint';
  public showPagination: boolean = true;
  public paginationData = {
    page: 1,
    limit: 10,
    totalPage: 1,
  }
  /* filters */
  searchChangeObserver: any;
  public searchInputValue = '';

  /* Excel variables */
  public excelData = {};
  public singleSheetExl:boolean = true;

  public gblSrchType:string = 'route';
  public cols = [];
  public tableData:any = [];
  generalSetting: boolean = false;
  public routeCols = [ 

    { key: '#', display: '#' }, 

    { 

      key: 'title', display: 'Route name', config: { 

        isTruncate: true, 

        truncateData: { 

          limit: 60, 

          concatVal: '...', 

        }, 

      }, 

      headerConfig:{ isDefault: true} 

    }, 

    { key: 'vehicleCount', display: '#Vehicles' }, 

    { key: 'fromDate', display: 'From date',headerConfig:{ isDefault: true} }, 

    { key: 'trasitMode', display: 'Transit mode',headerConfig:{ isDefault: true} }, 

 
 

    { key: 'attendence', display: 'Attendance', config: { isAttendance: true, } }, 

    // { key: 'keywords', display: 'Keywords' }, 

    // { key: 'holidayPattern', display: 'Holiday Pattern' }, 

    { key: 'startTime', display: 'Start time' ,headerConfig:{ isDefault: true}}, 

    { key: 'endTime', display: 'End time',headerConfig:{ isDefault: true} }, 

    { key: 'routeTypeName', display: 'Route type',headerConfig:{ isDefault: true} }, 
   

    { 

      key: 'action', 

      display: 'Action', 

      config: { 

        isAction: true, 

        actions: [ 

          // { display: 'view', color: 'primary', icon: 'View' }, 

          { display: 'Excel Download', color: 'tablebtnSuccess', icon: 'ExcelDocument' }, 

          { display: 'Update', color: 'primary', icon: 'Edit', class:'fs-13' }, 

          { display: 'Delete', color: 'warn', icon: 'Delete' } 

        ] 

      } 

    },
    { key: 'isEnable', display: ' ',config:{
      isEnable:true,
    
    } }, 

  ]; 

 
  public vehicleCols = [
    { key: '#', display: '#' },
    { key: 'vehicle', display: 'Reg no', config: { isUppercase: true } },
    {
      key: 'routeName', display: 'Route name', config: {
        isTruncate: true,
        truncateData: {
          limit: 60,
          concatVal: '...',
        }
      }
    },
    {
      key: 'action',
      display: 'Action',
      config: {
        isAction: true,
        actions: [
          { display: 'Update', color: 'primary', icon: 'Edit' }
        ]
      }
    }
  ];
  public ppCols = [
    { key: '#', display: '#' },
    {
      key: 'ppName', display: 'Pickup point', config: {
        isTruncate: true,
        truncateData: {
          limit: 80,
          concatVal: '...',
        }
      }
    },
    { key: 'vehRegNo', display: 'Reg no', config: { isUppercase: true } },
    {
      key: 'routeName', display: 'Route name', config: {
        isTruncate: true,
        truncateData: {
          limit: 60,
          concatVal: '...',
        }
      }
    },
    {
      key: 'action',
      display: 'Action',
      config: {
        isAction: true,
        actions: [
          { display: 'Update', color: 'primary', icon: 'Edit' }
        ]
      }
    }
  ];
  public empCols = [
    { key: '#', display: '#' },
    {
      key: 'empName', display: 'Employee name',
    },
    {
      key: 'empRefID', display: 'Employee ID', config: {
        isUppercase: true,
      }
    },
    {
      key: 'ppName', display: 'Pickup point', config: {
        isTruncate: true,
        truncateData: {
          limit: 60,
          concatVal: '...',
        }
      }
    },
    { key: 'vehRegNo', display: 'Reg no', config: { isUppercase: true } },
    {
      key: 'routeName', display: 'Route name', config: {
        isTruncate: true,
        truncateData: {
          limit: 60,
          concatVal: '...',
        }
      }
    },
    {
      key: 'action',
      display: 'Action',
      config: {
        isAction: true,
        actions: [
          { display: 'Update', color: 'primary', icon: 'Edit' }
        ]
      }
    }
  ]

  public searchFocused:boolean = false;
  public mappingField:any = {};
  public userRestrictionData:any={};
  public showConRosBtn:boolean=false;

  constructor(
    private api: ApiService,
    private route: Router,
    public swal: SweetAlert,
    public storage: StorageService,
    private comservice: CommonServices,
    private loader: LoaderService,
    private excel: ExcelExportService,
    private fieldMap:FieldMapPipe
  ) {
    this.userData = this.storage.get('userInfo');

    // let userInfo = this.storage.get('userInfo');
     if (this.userData?.general?.event == true) this.generalSetting = true;
    if(this.generalSetting==true){
      let object:any= { key: 'vehiclenumber', display: 'Vehicle number',headerConfig:{ isDefault: true}, config: { isUppercase: true }}
      this.routeCols.splice(8, 0, object);
     
    }

    const obj = {
      orgID: this.userData.orgID
    };
    this.api.org_settingsList(obj).then((res: any) => {
      this.showConRosBtn=true;
        let mail=this.userData.userEmail;
        let selectedUser=res.data['userInfo'].filter(e=> e.userEmail==mail);
        this.userData['fieldMap']=selectedUser[0]['fieldMap'];
        this.storage.setData({ userInfo: this.userData });
        let user = this.userData;
        if(user && user['fieldMap']){
          this.userRestrictionData=user['fieldMap'];
        }
    }).catch((err) => {
        console.log(err);
    });
  }

  ngOnInit(): void {
    setTimeout(() => { this.getRouteData(); }, 1000);
  }
  getRouteData(page = 1, limit = 10, search?) {
    this.routeData = [];
    this.tableData = [];
    this.cols = this.routeCols;
    //  this.api.transportMangerRouteList
    this.noDataFoundEnable = false;
    this.isShowSearchAnother = false;
    let obj = { page, limit };
    if (search) obj['title'] = search;
    this.api.transportMangerRouteList(obj).then((res: any) => {
    
      if (res.status == 'success') {
        if (res.data.length > 0) {
         
          this.searchShow = true;
          for (let d = 0; d < res.data.length; d++) {
            let item = res.data[d];
            let routeObj = this.processRouteObj(item);
            if (item.toDate) routeObj['toDate'] = this.comservice.timestampToDate(item.toDate, 'DMY', '-');

            this.routeData.push(routeObj);
            this.tableData.push(routeObj);
          }
        }else{
          this.searchShow = false;
        }
        this.processPagination(res, obj);
        setTimeout(() => {
          this.noDataFoundEnable = true;
          this.tableShow = true;
        }, 500)
      }else{
        this.searchShow = false;
      }
    });
  }

  processRouteObj(item){
    let returnObj = {
      title: item.title,
      trasitMode: item.trasitMode,
      attendence: typeof item.attendence == 'string' ? item.attendence : item.attendence.join(`, `),
      /*  startTime: this.getTimeString(item.startTime),
       endTime: this.getTimeString(item.endTime), */
      startTime: this.getTimeString(item.startTimeStr),
      endTime: this.getTimeString(item.endTimeStr),
      routeType: item.routeType,
      routeTypeName: item.routeType == 'openBooking' ? 'Open Booking' : item.routeType,
      keywords: item.keywords,
      holidayPattern: item.holidayPattern,
      orgID: item.orgID,
      routeID: item.routeID,
      status: item.status,
      fromDate: this.comservice.timestampToDate(item.fromDate, 'DMY', '-'),
      vehicle: item.vehicle,
     // vehiclenumber:item.vehicle,
      vehicleCount: this.getVehicleCount(item.vehicle),
      isEnable: item['isEnable'] ==0 ?'Cancel':' '
    };
    if(this.generalSetting==true){
      returnObj['vehiclenumber']= item.vehicle;
    }
    returnObj['routeTypeName'] = this.fieldMap.transform(returnObj['routeTypeName'],this.mappingField,['route/rostering','menuButtons',returnObj.routeType,'name'])
    return returnObj;
  }

  onSearchChange(searchValue: string) {

    searchValue = searchValue.trim().replace(/[^a-zA-Z0-9-_&, ]/g, '');

    if (!this.searchChangeObserver) {
      new Observable(observer => {
        this.searchChangeObserver = observer;
      }).pipe(debounceTime(500)) // wait 500ms after the last event before emitting last event
        .pipe(distinctUntilChanged()) // only emit if value is different from previous value
        .subscribe((term: any) => {
          // your code here
          this.searchInputValue = term;
          if (String(term).length == 0) this.getRouteData(1, this.paginationData.limit, term);
          else if (String(term).length >= 2) this.getRouteData(1, this.paginationData.limit, term);

        });
    }

    this.searchChangeObserver.next(searchValue);
  }


  routeAPIsearch(apiMethod,page=1,limit=10){
    return new Promise((resolve,reject)=>{
      let obj = { };
     try{
        this.api[apiMethod](obj).then(async (res: any) => {
          if (res.status == 'success') {
            if (res.data && res.data.length > 0) {
              resolve(res.data);
            }else{
              reject([]);
            }
          }else reject([]);
        }).catch((err)=>{
          console.log(err);
          reject([]);
        });
      }catch(err){
        console.log(err);
        reject([])
      }
    })

  }

  processPagination(data, req) {
    this.tableShow = false;
    this.paginationData = {
      page: req.page,
      limit: req.limit,
      totalPage: this.getTotalCount(data.totCnt, req.limit),
    }
    this.tableShow = true;
  }

  getTotalCount(total, limit) {
    let result: any = 1;
    if (total / limit > 0) {
      result = total / limit;
      if (total % limit > 0) result++;
    }
    return Math.floor(result);
  }

  pagination(data) {
    this.getRouteData(data.page, data.limit);
  }

  getVehicleCount(vehicles) {
    let count = 0;
    if (vehicles && vehicles.length > 0) {
      count = vehicles.length;
    }
    return count;
  }

  getTimeString(timeString) {                             // time '10:20'
    let splitTime = String(timeString).split(":");            // 10, 20
    splitTime[1] = splitTime[1] == undefined ? '0' : splitTime[1];

    let hour = this.comservice.pad(Number(splitTime[0]));
    let minute = this.comservice.pad(Number(splitTime[1]));

    let timeformat = `${hour}:${minute}`;
    return timeformat;
  }

  onActionHandler(e: any) {
    if (e && e.action.display == 'Update') {
      console.log(this.gblSrchType,e.data)
      if(this.gblSrchType=='vehicle'){
        this.route.navigate(['organization/transport-manager/rostering/edit-route/' + e.data.routeType + '/' + e.data.routeID + '/' + e.data.vehicle])
      }
      else if(this.gblSrchType=='pickuppoint' || this.gblSrchType=='employee'){
        this.route.navigate(['organization/transport-manager/rostering/edit-route/' + e.data.routeType + '/' + e.data.routeID + '/' + e.data.vehRegNo])
      }
      else{
        this.route.navigate(['organization/transport-manager/rostering/edit-route/' + e.data.routeType + '/' + e.data.routeID + '/0'])
      }
      //  console.log('organization/transport-manager/rostering/create-route/'+e.data.routeType+'/'+e.data.routeID)

    }
    if (e && e.action.display == 'Delete') {
      let routeID = e.data.routeID;
      this.delete(routeID);
    }
    if (e && e.action.display == 'Excel Download') {
      this.downloadRouteExcel(e.data.routeID);
    }
  }

  downloadAllRoute(e, type) {
    e.preventDefault();
    if (type == 'multipleSheet') {
      this.singleSheetExl = false;
    } else if (type == 'singleSheet') {
      this.singleSheetExl = true;
    }
    this.downloadRouteExcel('all');
  }

  async downloadRouteExcel(routeID) {
    try {
      this.loader.show();
      this.excelData = {};
      let apiData = await this.getRouteWiseExlReport({ routeID: [routeID] }).catch((err) => { console.log(err); });
      let routeIDs = Object.keys(apiData);

      if (routeIDs.length > 0) {
        let rowCount = 0;
        let routeCount = 0;
        let endCell = 'I';
        for (let r = 0; r < routeIDs.length; r++) {
          let routeData = apiData[routeIDs[r]];
          if (routeData) {
            let customizedExlInfo: any = await this.processRouteExlData(routeData, rowCount, endCell,routeCount).catch((err) => { console.log(err); });
            if (Object.keys(customizedExlInfo).length>0) {
              if (!this.singleSheetExl) {
                let sheetName = this.comservice.convertTitleCase(routeData['routeInfo']['title'])
                if (this.excelData[sheetName] == undefined) { this.excelData[sheetName] = {}; }
                this.excelData[sheetName] = customizedExlInfo;
              } else {
                let sheetName = 'Route Details';
                if (this.excelData[sheetName] == undefined) { this.excelData[sheetName] = {}; }
                if (this.excelData[sheetName]['customizedData'] == undefined) this.excelData[sheetName]['customizedData'] = [];
                this.excelData[sheetName]['customizedData'] = [ ...this.excelData[sheetName]['customizedData'],...customizedExlInfo['customizedData']];
                this.excelData[sheetName]['data'] = customizedExlInfo['data']
                
                rowCount = customizedExlInfo['rowCount'];
                routeCount = customizedExlInfo['routeCount'];
                if (r < routeIDs.length - 1) {
                    rowCount = rowCount + 1;
                    let vehDivder = {
                      value: [],
                      fill: {
                        type: 'pattern',
                        pattern: 'solid',
                        fgColor: { argb: 'FFFFFF00' },
                        bgColor: { argb: 'FF0000FF' }
                      },
                      border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
                    }
                  this.excelData['Route Details']['customizedData'] = [...this.excelData['Route Details']['customizedData'], { mergeCells: `A${rowCount + ''}:${endCell + rowCount + ''}`, ...vehDivder }];
                }
              }
            }
          }
        }
        if (Object.keys(this.excelData).length > 0) {
          console.log(this.excelData)
          let excelFileName = 'Route_Report_' + this.comservice.timestampToDate(new Date().getTime(), 'DMY_H_M_S') + '.xlsx'
          if (routeID == 'all') {
            excelFileName = 'Route_Report' + (this.singleSheetExl ? '_Single_Sheet_' : '_Multiple_Sheet_') + this.comservice.timestampToDate(new Date().getTime(), 'DMY_H_M_S') + '.xlsx'
          }
          this.excel.generateExcel(this.excelData, excelFileName);
        }
      }
      this.loader.hide();

    } catch (err) {
      console.log(err);
    }

  }

  processRouteExlData(apiData, rowCount, endCell, routeCount) {
    return new Promise(async (resolve, reject) => {
      try {
        let vehicles = [];
        let startDate = new Date(new Date().setHours(0, 0, 0));
        let endDate = new Date();
        let apiResKeys = Object.keys(apiData);
        if (apiResKeys.length > 1) {
          vehicles = apiResKeys.filter(item => item != 'routeInfo');
        }
        // let vehRegNo = [];
        // if (!Array.isArray(vehRegNo)) vehicles = [vehRegNo];
        // else vehicles = vehRegNo;
        let pdata: any = [], excel = [], customizedData = [];

        rowCount = rowCount + 2;
        routeCount = routeCount + 1
        let titleRow = {
          value: this.singleSheetExl ? [`Route - ${routeCount}`] : ['Route Information'],
          font: { name: 'Corbel', family: 4, size: 16, underline: 'double', bold: true },
          mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
        }
        customizedData.push(titleRow);

        rowCount = rowCount + 7;
        let routeType = apiData['routeInfo']['routeType'] == 'openBooking' ? 'Open Booking' : apiData['routeInfo']['routeType'];
        
        routeType = this.fieldMap.transform(routeType,this.mappingField,['route/rostering','menuButtons',apiData['routeInfo']['routeType'],'name'])
        routeType = this.comservice.convertTitleCase(routeType);
        
        let subtitleRow = {
          value: ["Route Name  : " + this.comservice.convertTitleCase(apiData['routeInfo']['title']) + "\n" +
            "From Date     : " + this.comservice.timestampToDate(new Date(apiData['routeInfo']['fromDate']).getTime(), 'DMY') + "\n" +
            "Start Time     : " + apiData['routeInfo']['startTimeStr'] + "\n" +
            "End Time       : " + apiData['routeInfo']['endTimeStr'] + "\n" +
            "Route Type    : " + routeType + "\n" +
            "Build Type     : " + this.comservice.convertTitleCase(apiData['routeInfo']['buildType']) + "\n" +
            "Transit Mode : " + apiData['routeInfo']['trasitMode'] + ""],
          font: { name: 'Corbel', family: 4, size: 12, },
          mergeCells: `A${(rowCount - 6) + ''}:${endCell + rowCount + ''}`,
        }

        customizedData.push(subtitleRow);

        rowCount = rowCount + 1;

        let dividerRow = {
          value: [],
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFFFF' }, //966462AF//FF808080
            bgColor: { argb: 'FFFFFFFF' } //966462AF//FF808080
          },
          border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
        }

        customizedData.push({ mergeCells: `A${rowCount + ''}:${endCell + rowCount + ''}`, ...dividerRow });

        rowCount = rowCount + 2;

        let vehicleTitle = {
          value: ['Vehicle Information'],
          font: { name: 'Corbel', family: 4, size: 16, underline: 'double', bold: true },
          mergeCells: `A${(rowCount - 1) + ''}:${endCell + rowCount + ''}`,
        }

        customizedData.push(vehicleTitle);

        if (vehicles.length <= 0) {
          rowCount = rowCount + 1;
          let noDataRow =
          {
            value: ['No Vehicles'],
            mergeCells: `A${(rowCount) + ''}:${endCell + rowCount + ''}`,
            alignment: { cell: `A${(rowCount)}`, value: { vertical: 'middle', horizontal: 'center' } },
          }
          customizedData.push(noDataRow)
        }

        for (let veh = 0; veh < vehicles.length; veh++) {

          if (vehicles[veh] != undefined) {

            let tempData: any = await this.processExlData(apiData[vehicles[veh]], vehicles[veh], endCell, rowCount);
            customizedData = [...customizedData, ...tempData['xlData']];
            rowCount = tempData['rowCount'];
            if (veh != vehicles.length - 1) {
              rowCount = rowCount + 1;
              let vehDivder = {
                value: [],
                fill: {
                  type: 'pattern',
                  pattern: 'solid',
                  fgColor: { argb: 'FFFFFFFF' }, //FFCCCCCC
                  bgColor: { argb: 'FFFFFFFF' }  //FFCCCCCC
                },
                border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } },
              }
              customizedData.push({ mergeCells: `A${rowCount + ''}:${endCell + rowCount + ''}`, ...vehDivder });
            }

          }
        }

        const customizedExlInfo = {
          customizedData: customizedData,
          data: {
            columWith: [{ colNo: 1, width: 10 }, { colNo: 2, width: 20 }, { colNo: 3, width: 15 }, { colNo: 4, width: 15 }, { colNo: 5, width: 30 }, { colNo: 6, width: 15 }, { colNo: 7, width: 15 }, { colNo: 8, width: 15 }, { colNo: 9, width: 50 }]
          },
          rowCount: rowCount,
          routeCount: routeCount,
        }
        resolve(customizedExlInfo);
      } catch (err) {
        reject({});
        console.log(err);
      }
    })
  }

  getRouteWiseExlReport(obj) {
    return new Promise((resolve, reject) => {
      try {
        this.api.transportManagerRouteWiseExlReport(obj).then((res: any) => {
          if (res.status == 'success') {
            resolve(res.data);
          }
          else resolve({});
        }).catch((err) => {
          console.log(err);
          resolve({});
        })
      } catch (err) {
        reject(err);
      }
    })
  }

  processExlData(data, vehRegNo, endCell, rowCount) {
    return new Promise((resolve, reject) => {
      try {
        let returnData = [];
        let exlData = [];
        let vehHeaderRow =
        {
          value: ['S No', 'Pickup point name', 'Lat', 'Lng', 'Location', 'Radius (km)', 'ETA', 'Traveller name', 'Traveller type'],
          fill: {
            type: 'pattern',
            pattern: 'solid',
            fgColor: { argb: 'FFFFFFFF' },
            bgColor: { argb: 'FFFFFFFF' }
          },
          font: { bold: true },
          border: { top: { style: 'thin' }, left: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' } }
        }
        if (data['locInfo']) {
          rowCount = rowCount + 5;
          let vehicleRow =
          {
            value: [
              "Vehicle Reg No    : " + (vehRegNo ? String(vehRegNo).toUpperCase() : '---') + "\n" +
              "Start Location      : " + (data['locInfo'] && data['locInfo'][0] && data['locInfo'][0]['startLoc'] && data['locInfo'][0]['startLoc']['name'] ? this.comservice.convertTitleCase(data['locInfo'][0]['startLoc']['name']) : '---') + "\n" +
              "End Location       : " + (data['locInfo'] && data['locInfo'][0] && data['locInfo'][0]['endLoc'] && data['locInfo'][0]['endLoc']['name'] ? this.comservice.convertTitleCase(data['locInfo'][0]['endLoc']['name']) : '---') + "\n" +
              "Distance (in Km)  :  " + (data['locInfo'] && data['locInfo'][0] && data['locInfo'][0]['distance'] ? Math.floor(Math.abs(Number(data['locInfo'][0]['distance']))) : '---') + "\n" +
              "Duration               : " + (data['locInfo'] && data['locInfo'][0] && data['locInfo'][0]['duration'] ? this.decimalToTime(data['locInfo'][0]['duration']) : '--:--:--') + ""
            ],
            font: { name: 'Corbel', family: 4, size: 12, },
            mergeCells: `A${(rowCount - 4) + ''}:${endCell + rowCount + ''}`,
          }
          returnData.push(vehicleRow);

          if (data['ppInfo'] && data['ppInfo'].length > 0) {

            let enableEmp: boolean = false;
            let enableGuest: boolean = false;
            let results: any = data['ppInfo'].map((pp: any) => {
              let pPobj = { ...pp };
              try {
                if (pp.eta) {
                  let eta = String(pp.eta).toLowerCase();
                  let [hour, min]: any = eta.split(':');
                  if (eta.includes('pm')) {
                    let val = eta.split(':');
                    hour = +val[0] + 12;
                    let [mins, meriden] = val[1].split(' ');
                    min = +mins;
                  }
                  let etaHrs = new Date(new Date().setHours(hour, min)).getHours();
                  let etaMins = new Date(new Date().setHours(hour, min)).getMinutes();
                  let finalEta = `${etaHrs}.${etaMins}`;
                  pPobj['etaDecimal'] = Number.parseFloat(finalEta);
                }
                if (pp.assignedEmployees && pp.assignedEmployees.length > 0) enableEmp = true;
                if (pp.assignedGuest && pp.assignedGuest.length > 0) enableGuest = true;
              }
              catch (err) {
                console.log(err)
              }
              return pPobj;
            })
            results = results.sort((a, b) => a.etaDecimal - b.etaDecimal);

            let rowCnt = rowCount + 2;
            results.map((item, index) => {
              let columnCount = 0;
              const res = {
                title: item.title ? this.comservice.convertTitleCase(item.title) : '---',
                lat: item.lat ? item.lat : '---',
                lng: item.lng ? item.lng : '---',
                location: item.location ? this.comservice.convertTitleCase(item.location) : '---',
                radius: item.radius ? item.radius : '---',
                eta: item.eta ? item.eta : '---',
                travellerType: '',
                travellers: '',
              };
              let multiRowVal = [{ value: [index + 1, res.title, res.lat, res.lng, res.location, res.radius, res.eta] }];
              if (enableEmp) {
                if (item.assignedEmployees && item.assignedEmployees.length > 0) {
                  let emps = item.assignedEmployees.map((emp) => {
                    let name = '--- - ---';
                    if (data['empInfo'] && Object.keys(data['empInfo']).length > 0 && data['empInfo'][emp]) {
                      if (data['empInfo'][emp]['name']) name = this.comservice.convertTitleCase(data['empInfo'][emp]['name']);
                      if (data['empInfo'][emp]['empRefID']) name = name + ' - ' + String(data['empInfo'][emp]['empRefID']).toUpperCase();
                    }
                    return name;
                  })
                  res['travellers'] = emps.join('\n');
                  emps.filter((emp) => {
                    if (res['travellerType'].length > 0) res['travellerType'] = res['travellerType'] + '\n' + 'Employee';
                    else res['travellerType'] = 'Employee';
                  })

                  columnCount = columnCount + emps.length;
                  multiRowVal[0]['value'].push(res['travellers'], res['travellerType']);
                }
              }
              if (enableGuest) {
                if (item.assignedGuest && item.assignedGuest.length > 0) {
                  let guests = item.assignedGuest.map((guest) => {
                    let name = '--- - ---';
                    if (data['guestInfo'] && Object.keys(data['guestInfo']).length > 0 && data['guestInfo'][guest]) {
                      if (data['guestInfo'][guest]['name']) name = this.comservice.convertTitleCase(data['guestInfo'][guest]['name']);
                      if (data['guestInfo'][guest]['userType']) name = name + ' - ' + this.comservice.convertTitleCase(data['guestInfo'][guest]['userType']);
                    }
                    return name;
                  })

                  if (res['travellers'].length > 0) res['travellers'] = res['travellers'] + '\n' + guests.join('\n');
                  else res['travellers'] = guests.join('\n');
                  guests.filter((guest) => {
                    if (res['travellerType'].length > 0) res['travellerType'] = res['travellerType'] + '\n' + 'Guest';
                    else res['travellerType'] = 'Guest';
                  })

                  columnCount = columnCount + guests.length;
                  multiRowVal[0]['value'][7] = res['travellers'];
                  multiRowVal[0]['value'][8] = res['travellerType'];
                }
              }
              if (columnCount >= 2) {
                multiRowVal[0]['mergeCells'] = [
                  `A${rowCnt}:A${rowCnt + columnCount - 1}`,
                  `B${rowCnt}:B${rowCnt + columnCount - 1}`,
                  `C${rowCnt}:C${rowCnt + columnCount - 1}`,
                  `D${rowCnt}:D${rowCnt + columnCount - 1}`,
                  `E${rowCnt}:E${rowCnt + columnCount - 1}`,
                  `F${rowCnt}:F${rowCnt + columnCount - 1}`,
                  `G${rowCnt}:G${rowCnt + columnCount - 1}`,
                  `H${rowCnt}:H${rowCnt + columnCount - 1}`,
                  `I${rowCnt}:I${rowCnt + columnCount - 1}`,
                ];
                multiRowVal[0]['alignment'] = [
                  { cell: `A${rowCnt}`, value: { vertical: 'top', horizontal: 'right' } },
                  { cell: `B${rowCnt}`, value: { vertical: 'top', horizontal: 'left' } },
                  { cell: `C${rowCnt}`, value: { vertical: 'top', horizontal: 'right' } },
                  { cell: `D${rowCnt}`, value: { vertical: 'top', horizontal: 'right' } },
                  { cell: `E${rowCnt}`, value: { vertical: 'top', horizontal: 'left' } },
                  { cell: `F${rowCnt}`, value: { vertical: 'top', horizontal: 'right' } },
                  { cell: `G${rowCnt}`, value: { vertical: 'top', horizontal: 'left' } },
                  { cell: `H${rowCnt}`, value: { vertical: 'top', horizontal: 'left' } },
                  { cell: `I${rowCnt}`, value: { vertical: 'top', horizontal: 'left' } },]
              }
              if (columnCount == 0) rowCnt = rowCnt + 1;
              rowCnt = rowCnt + columnCount;
              exlData = [...exlData, ...multiRowVal];
            });

            rowCount = rowCount + 1;

            returnData.push(vehHeaderRow);

            rowCount = rowCnt - 1;
            returnData = [...returnData, ...exlData];
            resolve({ rowCount: rowCount, xlData: returnData });
          }
          else {
            rowCount = rowCount + 1;
            returnData.push(vehHeaderRow);

            rowCount = rowCount + 1;
            let noDataRow =
            {
              value: ['No Pickup Points'],
              mergeCells: `A${(rowCount) + ''}:${endCell + rowCount + ''}`,
              alignment: { cell: `A${(rowCount)}`, value: { vertical: 'middle', horizontal: 'center' } },
            }
            returnData.push(noDataRow);

            resolve({ rowCount: rowCount, xlData: returnData });
          }
        }
        resolve({ rowCount: rowCount, xlData: returnData });
      } catch (err) {
        console.log(err);
        reject(err);
      }
    })
  }

  // decimal to Duration time
  decimalToTime(etd) {
    let hour = 0;
    let min = 0;
    // let min = Math.floor(Math.abs(etd));
    let arraySplit = String(etd).split('.');
    if (arraySplit[1]) {
      hour = Number(arraySplit[0]);
      min = Number(arraySplit[1]);
    }
    else hour = Number(arraySplit[0]);
    if (min > 60) { hour += Math.floor(min / 60); min = Math.floor(min % 60); }
    return (hour < 10 && String(hour).length == 1 ? "0" : "") + hour + ":" + (min < 10 && String(hour).length == 1 ? "0" : "") + min + ":00";
  }

  delete(id) {
    Swal.fire({
      title: 'Are you sure?',
      text: 'You want to delete this!',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Yes, delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        let obj = { id: id, forceDelete: false };
        this.deleteRoute(obj);

      }
    });
  }
  deleteRoute(dltObj) {
    let obj = {
      orgID: this.userData.orgID,
      routeID: dltObj['id'],
      forceDelete: dltObj['forceDelete'],
    };
    this.api.transportMangerRouteDelete(obj).then((res: any) => {
      if (res.status == 'success') {
        this.swal.swalFunction(res.status, res.status, res.message, 2000);
        this.noDataFoundEnable = false;
        this.tableShow = false;
        this.getRouteData();
      }
      if (res.status == 'failure') {
        this.forceDelete('warning', res.message, dltObj['id']);
        // this.swal.swalFunction('error', res.status, res.message, 3000);
      }
    }).catch((err) => {
      console.log(err);
    });
  }

  forceDelete(Icon: any, Text: any, id) {
    Swal.fire({
      title: 'Are you sure?',
      text: Text,
      icon: Icon.toLowerCase(),
      showCancelButton: true,
      confirmButtonColor: '#d33',
      confirmButtonText: 'Force delete it!'
    }).then((result) => {
      if (result.isConfirmed) {
        let obj = { id: id, forceDelete: true };
        this.deleteRoute(obj);
      }
    });
  }

  pageNavigate(path, $event) {
    const urlPath = 'organization/transport-manager/rostering/';
    setTimeout(() => {
      this.route.navigate([urlPath + path]);
    }, 10);
    // this.router.navigate(['/heroes', { id: heroId }]);
  }

  routeConfiguration() {
    console.log('route cut off');
    this.route.navigate(['organization/transport-manager/rostering/manage-route/configuration']);
  }

  rosterConfiguration(){
    this.route.navigate(['organization/transport-manager/rostering/manage-route/roster']);
  }

  async getGlobalSearchRes(obj){
    console.log(obj)
    this.noDataFoundEnable = false;
    if(Object.keys(obj).length > 0){
      this.isShowSearchAnother = false;
      this.emptySrch = false
      this.gblSrchType = obj['type'] ? obj['type'] : 'route';
      if(obj['type']=='vehicle'){
          this.tableShow = false;
          this.cols = this.vehicleCols;
          let data = obj['obj']
          if(!Array.isArray(data)) data = [data];
          this.tableData = data;
          
      }else if(obj['type']=='pickuppoint'){
          this.tableShow = false;
          this.cols = this.ppCols;
          let data = obj['obj']
          if(!Array.isArray(data)) data = [data];
          this.tableData = data;

          
        }else if(obj['type']=='employee'){
          this.tableShow = false;
          this.cols = this.empCols;
          let data = obj['obj']
          if(!Array.isArray(data)) data = [data];
          this.tableData = data;          
        }else if(obj['type']=='route'){
          this.tableShow = false;
          this.cols = this.routeCols;
          let data = obj['obj']
          if(!Array.isArray(data)) data = [data];
          this.tableData = data.map((item)=>this.processRouteObj(item));
        }
        this.tableShow = true;
      }
    else{
      if(this.gblSrchType=='vehicle'){
        this.tableShow = false;
        this.cols = this.vehicleCols;
        let vehicles = await this.routeAPIsearch('transportManagerRouteVehSearch').catch((err)=>{ console.log(err); return [];})
        this.tableData = vehicles;
        this.tableShow = true;
      this.isShowSearchAnother = true;
      }else if(this.gblSrchType=='pickuppoint'){
        this.tableShow = false;
        this.cols = this.ppCols;
        let pickupPoints:any = await this.routeAPIsearch('transportManagerRoutePPSearch').catch((err)=>{ console.log(err); return [];})
        this.tableData = pickupPoints;
        this.tableShow = true;
      this.isShowSearchAnother = true;
      }else if(this.gblSrchType=='employee'){
        this.tableShow = false;
        this.cols = this.empCols;
        let employees:any = await this.routeAPIsearch('transportManagerRouteEmpSearch').catch((err)=>{ console.log(err); return [];})
        this.tableData = employees;
        this.tableShow = true;
      this.isShowSearchAnother = true;
      }else {
        if(!this.emptySrch){
          this.getRouteData();
          this.emptySrch = true;
        }

      }
    }
  }

}
